import {FieldPath} from 'react-hook-form'

import {FieldsConfiguration, FieldsForm} from '../../fields/types'

export type WizardProgressItemType = 'current' | 'done' | 'default'

export type WizardItemProps = {
  type: WizardProgressItemType
  onPress: () => void
  index: number
}

export type WizardItem = {
  //type: WizardProgressItemType;
  title: string
  value?: string
  containerTestId?: string
  valueTestId?: string
}

export type WizardItemOrComponent = WizardItem | React.FC<WizardItemProps>

export type EditorComponentProps = {
  onSuccess: () => void
  successButtonType: 'next' | 'done'
  successButtonText?: string
}

export type StepComponentProps = Omit<
  EditorComponentProps,
  'onSuccess' | 'successButtonType' | 'successButtonText'
>

export type StepComponent<T extends EditorComponentProps = EditorComponentProps> = React.FC<
  Omit<T, 'successButtonType' | 'successButtonText'>
>

// this one is not yet used, could be removed if not needed
export type OrderIntakeFieldStepFactory<T, C, TField extends FieldPath<FieldsForm>> = {
  key: keyof T // do i need typing here??
  fields: TField // what with multiple fields?
  factory: (input: {
    //value: PathValue<FieldsForm, TField>; <-- what if we got step that merge multiple fields?
    stepConfiguration: C
    fieldConfiguration: FieldsConfiguration
    value: string
  }) => OrderIntakeStep<T>
}

export type OrderIntakeStepFactory<T, C> = {
  key: T
  factory: (input: {
    fieldConfiguration: FieldsConfiguration
    stepConfiguration: C
  }) => OrderIntakeStep<T>
}

export type OrderIntakeStepFactories<T, C> = (
  | {
      [P in FieldPath<FieldsForm>]: OrderIntakeFieldStepFactory<T, C, P>
    }[FieldPath<FieldsForm>]
  | OrderIntakeStepFactory<T, C>
)[]

export function isOrderIntakeFieldStepFactory<T, C, P extends FieldPath<FieldsForm>>(
  itemFactory: OrderIntakeFieldStepFactory<T, C, P> | OrderIntakeStepFactory<T, C>
): itemFactory is OrderIntakeFieldStepFactory<T, C, P> {
  return (itemFactory as OrderIntakeFieldStepFactory<T, C, P>).fields !== undefined
}

export type OrderIntakeStep<T = string> = {
  // editor component to render
  Component: StepComponent<EditorComponentProps>
  // wizard progress item to render or component; TODO: maybe we can split into 2 props?
  wizardItem: WizardItemOrComponent
  isEnabled: boolean
  key: T // Store the step type here
}
